import { resolveImageUrl } from "../../utils/imageStorage.js";
import {
  ChevronRight,
  CheckCircle2,
  ArrowRight,
  Sparkles,
  MapPin,
  Phone,
  Building2,
  Clock,
  ShieldCheck
} from "lucide-react";
export const HomePage = ({
  settings,
  posts,
  curriculum,
  lang,
  onNavigate,
  pageData
}) => {
  const publishedPosts = posts.filter((p) => p.status === "published").slice(0, 3);
  const activeCurriculum = curriculum.filter((c) => c.is_active).slice(0, 4);
  const heroImage = resolveImageUrl(pageData?.hero_image || "/assets/images/uploads/madrasah_campus_hero_1790844614157.jpg");
  const classroomPhoto = resolveImageUrl(pageData?.photos?.find((p) => p.key === "classroom")?.url || "/assets/images/uploads/madrasah_campus_hero_1790844614157.jpg");
  const booksPhoto = resolveImageUrl(pageData?.photos?.find((p) => p.key === "curriculum")?.url || "/assets/images/uploads/madrasah_campus_hero_1790844614157.jpg");
  const teachersPhoto = resolveImageUrl(pageData?.photos?.find((p) => p.key === "teachers")?.url || "/assets/images/uploads/madrasah_campus_hero_1790844614157.jpg");
  const campusPhoto = resolveImageUrl(pageData?.photos?.find((p) => p.key === "campus")?.url || heroImage);
  return <div className="space-y-16 sm:space-y-24">
      {
    /* 1. HERO SECTION WITH ARABIC MOTTO & BILINGUAL VALUE PROPOSITION */
  }
      <section className="relative overflow-hidden bg-emerald-950/80 backdrop-blur-md text-white pt-20 pb-28 md:pt-28 md:pb-36">
        {
    /* Subtle geometric islamic background overlay */
  }
        <div className="absolute inset-0 opacity-10 pointer-events-none bg-[radial-gradient(#fbbf24_1px,transparent_1px)] [background-size:24px_24px]" />

        {
    /* Dynamic Background Banner Image with gradient */
  }
        {heroImage && <div className="absolute inset-0 opacity-20 pointer-events-none mix-blend-overlay">
            <img
    src={heroImage}
    alt=""
    className="w-full h-full object-cover"
    referrerPolicy="no-referrer"
  />
          </div>}

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          {
    /* Bismillah & Madrasah Identity */
  }
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-emerald-900/80 border border-emerald-700/60 text-amber-300 text-xs font-semibold uppercase tracking-widest mb-6 font-arabic shadow-sm">
            <Sparkles className="w-3.5 h-3.5" />
            <span>{settings.bismillah_header}</span>
          </div>

          {
    /* Madrasah Main Name */
  }
          <div className="mb-4">
            <span className="text-xs sm:text-sm font-bold tracking-widest text-emerald-300 uppercase block font-sans">
              {lang === "bn" ? settings.site_name : settings.site_name_bn}
            </span>
            <span className="text-3xl sm:text-5xl lg:text-6xl font-serif font-extrabold text-amber-300 tracking-tight block mt-1">
              {lang === "bn" ? settings.site_name_bn : settings.site_name}
            </span>
          </div>

          {
    /* Main Hero Headline */
  }
          <h1 className="text-xl sm:text-3xl lg:text-4xl font-serif font-bold text-white tracking-tight max-w-4xl mx-auto mb-5 leading-snug">
            {lang === "bn" ? pageData?.subtitle_bn || "\u0987\u09B9\u0995\u09BE\u09B2\u09C0\u09A8 \u0993 \u09AA\u09B0\u0995\u09BE\u09B2\u09C0\u09A8 \u09B8\u09AB\u09B2\u09A4\u09BE\u09B0 \u0986\u09A6\u09B0\u09CD\u09B6 \u09AC\u09BF\u09A6\u09CD\u09AF\u09BE\u09AA\u09C0\u09A0\u0964" : pageData?.subtitle || "Learning for this life and the next."}
          </h1>

          {
    /* Subtitle */
  }
          <p className="text-base sm:text-lg lg:text-xl text-emerald-100/90 max-w-2xl mx-auto font-sans leading-relaxed mb-8">
            {lang === "bn" ? pageData?.content_bn || "\u098F\u0995\u099F\u09BF \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09AF\u09CB\u0997\u09CD\u09AF \u09AE\u09A1\u09C7\u09B2 \u09AE\u09BE\u09A6\u09CD\u09B0\u09BE\u09B8\u09BE \u09AF\u09C7\u0996\u09BE\u09A8\u09C7 \u09AA\u09AC\u09BF\u09A4\u09CD\u09B0 \u0995\u09C1\u09B0\u0986\u09A8\u09C7\u09B0 \u0986\u09A6\u09B0\u09CD\u09B6, \u099A\u09BE\u09B0\u09BF\u09A4\u09CD\u09B0\u09BF\u0995 \u09AE\u09B9\u09A4\u09CD\u09A4\u09CD\u09AC \u098F\u09AC\u0982 \u0986\u09A7\u09C1\u09A8\u09BF\u0995 \u09B8\u09BE\u09A7\u09BE\u09B0\u09A3 \u09B6\u09BF\u0995\u09CD\u09B7\u09BE \u098F\u0995\u09B8\u09BE\u09A5\u09C7 \u09AC\u09BF\u0995\u09B6\u09BF\u09A4 \u09B9\u09AF\u09BC\u0964" : pageData?.content || "A caring model madrasah where Quranic values and modern learning come together."}
          </p>

          {
    /* CTA Buttons */
  }
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3.5 max-w-md mx-auto">
            <button
    onClick={() => onNavigate("about")}
    className="w-full sm:w-auto px-7 py-3.5 text-sm font-bold text-emerald-950 bg-amber-400 hover:bg-amber-300 rounded-full shadow-lg transition-all transform active:scale-98 cursor-pointer"
  >
              {lang === "bn" ? "\u09AE\u09BE\u09A6\u09CD\u09B0\u09BE\u09B8\u09BE\u09B0 \u09AC\u09BF\u09B8\u09CD\u09A4\u09BE\u09B0\u09BF\u09A4 \u099C\u09BE\u09A8\u09C1\u09A8" : "Discover Our Madrasah"}
            </button>
            <button
    onClick={() => onNavigate("curriculum")}
    className="w-full sm:w-auto px-7 py-3.5 text-sm font-semibold text-white border-2 border-white/80 hover:bg-white/10 rounded-full transition-all cursor-pointer"
  >
              {lang === "bn" ? "\u0995\u09BE\u09B0\u09BF\u0995\u09C1\u09B2\u09BE\u09AE \u09A6\u09C7\u0996\u09C1\u09A8" : "Explore Curriculum"}
            </button>
          </div>

          {
    /* Location badge in hero */
  }
          <div className="mt-8 pt-4 flex items-center justify-center gap-2 text-xs text-amber-200/80 font-medium">
            <MapPin className="w-3.5 h-3.5 text-amber-400" />
            <span>{lang === "bn" ? settings.address_bn : settings.address}</span>
          </div>
        </div>
      </section>

      {
    /* 2. LIVE ADMISSION & NOTICE TICKER */
  }
      <section className="bg-amber-500 text-emerald-950 py-3 px-4 shadow-xs border-y border-amber-600">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="flex items-center gap-2.5 overflow-hidden text-xs sm:text-sm font-semibold">
            <span className="bg-emerald-950 text-amber-400 px-2.5 py-0.5 rounded text-[11px] font-bold uppercase shrink-0">
              {lang === "bn" ? "\u09A8\u09CB\u099F\u09BF\u09B6" : "Notice"}
            </span>
            <span className="truncate">
              {lang === "bn" ? settings.notice_ticker_bn : settings.notice_ticker}
            </span>
          </div>
          <button
    onClick={() => onNavigate("contact")}
    className="shrink-0 text-xs font-bold text-emerald-950 underline hover:text-emerald-900 cursor-pointer flex items-center gap-1"
  >
            <span>{lang === "bn" ? "\u09AD\u09B0\u09CD\u09A4\u09BF \u09AB\u09B0\u09AE \u09AA\u09C2\u09B0\u09A3 \u0995\u09B0\u09C1\u09A8" : "Apply Online"}</span>
            <ChevronRight className="w-3.5 h-3.5" />
          </button>
        </div>
      </section>

      {
    /* 3. SIGNATURE DUAL-STREAM INTEGRATED CURRICULUM */
  }
      <section className="py-20 bg-stone-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-14">
            <span className="text-emerald-800 font-bold text-xs uppercase tracking-wider block mb-2">
              {lang === "bn" ? "\u09B8\u09AE\u09A8\u09CD\u09AC\u09BF\u09A4 \u09B6\u09BF\u0995\u09CD\u09B7\u09BE\u0995\u09CD\u09B0\u09AE" : "Integrated Curriculum"}
            </span>
            <h2 className="text-2xl sm:text-4xl font-serif font-bold text-slate-900 tracking-tight text-balance">
              {lang === "bn" ? "\u09B8\u09AE\u09A8\u09CD\u09AC\u09BF\u09A4 \u0995\u09BE\u09B0\u09BF\u0995\u09C1\u09B2\u09BE\u09AE\u09C7 \u09AC\u09BE\u09AF\u09BC\u09A4\u09C1\u09B2 \u09AE\u09C1\u0995\u09BE\u09A6\u09CD\u09A6\u09BE\u09B8 \u09AE\u09A1\u09C7\u09B2 \u09AE\u09BE\u09A6\u09CD\u09B0\u09BE\u09B8\u09BE" : "Balanced Multi-Disciplinary Curriculum"}
            </h2>
            <p className="mt-3 text-sm sm:text-base text-slate-600">
              {lang === "bn" ? "\u09A6\u09CD\u09AC\u09C0\u09A8\u09BF \u09AC\u09C1\u09A8\u09BF\u09DF\u09BE\u09A6\u09BF \u09B6\u09BF\u0995\u09CD\u09B7\u09BE\u09B0 \u09B8\u09BE\u09A5\u09C7 \u099C\u09BE\u09A4\u09C0\u09DF \u09B6\u09BF\u0995\u09CD\u09B7\u09BE\u0995\u09CD\u09B0\u09AE\u09C7\u09B0 \u0986\u09A7\u09C1\u09A8\u09BF\u0995 \u099C\u09CD\u099E\u09BE\u09A8\u2014\u09B6\u09BF\u09B6\u09C1\u09B0 \u09AE\u09C7\u09A7\u09BE \u0993 \u0986\u09A4\u09CD\u09AE\u09BF\u0995 \u09AC\u09BF\u0995\u09BE\u09B6\u09C7\u09B0 \u098F\u0995 \u0985\u09B8\u09BE\u09A7\u09BE\u09B0\u09A3 \u09B0\u09C2\u09AA\u09B0\u09C7\u0996\u09BE\u0964" : "Fusing traditional Noorani Tajweed and Tahfiz with modern national primary standards (Bangla, English, Math, Science)."}
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6">
            {activeCurriculum.map((item) => <div
    key={item.id}
    className="bg-white rounded-2xl p-5 sm:p-6 border border-stone-200 shadow-xs hover:shadow-md transition-all hover:border-emerald-600/60 flex flex-col justify-between group"
  >
                <div>
                  <div className="flex items-center justify-between mb-3.5">
                    <span className="text-[11px] font-bold text-emerald-800 bg-emerald-50 px-2.5 py-1 rounded-full border border-emerald-100">
                      {item.age_group}
                    </span>
                    <span className="text-[11px] text-slate-400 font-mono">{item.duration}</span>
                  </div>

                  <h3 className="text-base sm:text-lg font-bold text-slate-900 mb-2 font-serif group-hover:text-emerald-800 transition-colors leading-snug">
                    {lang === "bn" ? item.class_name_bn : item.class_name}
                  </h3>

                  <p className="text-xs text-slate-600 leading-relaxed mb-4 line-clamp-3">
                    {lang === "bn" ? item.description_bn : item.description}
                  </p>

                  <div className="space-y-2 pt-2 border-t border-stone-100">
                    <span className="text-[10px] font-bold text-slate-700 uppercase tracking-wider block">
                      {lang === "bn" ? "\u09AA\u09BE\u09A0\u09CD\u09AF \u09AC\u09BF\u09B7\u09DF\u09B8\u09AE\u09C2\u09B9:" : "Subjects Included:"}
                    </span>
                    <div className="flex flex-wrap gap-1.5">
                      {(lang === "bn" ? item.subjects_bn : item.subjects).map((subj, idx) => <span
    key={idx}
    className="text-[10px] bg-stone-100 text-slate-700 px-2 py-0.5 rounded font-medium"
  >
                          {subj}
                        </span>)}
                    </div>
                  </div>
                </div>

                <div className="mt-5 pt-3.5 border-t border-stone-100 flex items-center justify-between">
                  <span className="text-[10px] text-slate-500 font-mono">{item.schedule}</span>
                  <button
    onClick={() => onNavigate("contact")}
    className="text-xs font-bold text-emerald-800 hover:text-emerald-950 flex items-center gap-1 cursor-pointer"
  >
                    <span>{lang === "bn" ? "\u09AD\u09B0\u09CD\u09A4\u09BF \u0986\u09AC\u09C7\u09A6\u09A8" : "Apply Now"}</span>
                    <ArrowRight className="w-3.5 h-3.5" />
                  </button>
                </div>
              </div>)}
          </div>

          <div className="mt-12 text-center">
            <button
    onClick={() => onNavigate("curriculum")}
    className="inline-flex items-center gap-2 px-8 py-3 bg-emerald-800 hover:bg-emerald-900 text-white rounded-full text-xs font-bold transition-all shadow-sm cursor-pointer"
  >
              <span>{lang === "bn" ? "\u09AA\u09C2\u09B0\u09CD\u09A3\u09BE\u0999\u09CD\u0997 \u09B8\u09BF\u09B2\u09C7\u09AC\u09BE\u09B8 \u0993 \u09AC\u09BF\u09B8\u09CD\u09A4\u09BE\u09B0\u09BF\u09A4 \u09AC\u09BF\u09AC\u09B0\u09A3" : "View Full Academic Syllabus"}</span>
              <ChevronRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      </section>

      {
    /* 4. VISUAL PHOTO GALLERY & CAMPUS ENVIRONMENT */
  }
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            {
    /* Left Column: 4 Real Madrasah Photos (All Dynamic) */
  }
            <div className="lg:col-span-6 grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <div className="rounded-xl overflow-hidden border border-stone-200 shadow-sm">
                  <img
    src={classroomPhoto}
    alt="Students in classroom"
    className="w-full h-48 sm:h-60 object-cover hover:scale-102 transition-transform duration-300"
    referrerPolicy="no-referrer"
    onError={(e) => {
      e.currentTarget.src = "/assets/images/uploads/madrasah_campus_hero_1790844614157.jpg";
    }}
  />
                </div>
                <div className="rounded-xl overflow-hidden border border-stone-200 shadow-sm">
                  <img
    src={booksPhoto}
    alt="Curriculum books and Arabic calligraphy"
    className="w-full h-40 sm:h-48 object-cover hover:scale-102 transition-transform duration-300"
    referrerPolicy="no-referrer"
    onError={(e) => {
      e.currentTarget.src = "/assets/images/uploads/madrasah_campus_hero_1790844614157.jpg";
    }}
  />
                </div>
              </div>
              <div className="space-y-4 pt-6">
                <div className="rounded-xl overflow-hidden border border-stone-200 shadow-sm">
                  <img
    src={teachersPhoto}
    alt="Scholars and teachers"
    className="w-full h-40 sm:h-48 object-cover hover:scale-102 transition-transform duration-300"
    referrerPolicy="no-referrer"
    onError={(e) => {
      e.currentTarget.src = "/assets/images/uploads/madrasah_campus_hero_1790844614157.jpg";
    }}
  />
                </div>
                <div className="rounded-xl overflow-hidden border border-stone-200 shadow-sm">
                  <img
    src={campusPhoto}
    alt="Madrasah building architecture"
    className="w-full h-48 sm:h-60 object-cover hover:scale-102 transition-transform duration-300"
    referrerPolicy="no-referrer"
    onError={(e) => {
      e.currentTarget.src = "/assets/images/uploads/madrasah_campus_hero_1790844614157.jpg";
    }}
  />
                </div>
              </div>
            </div>

            {
    /* Right Column: Educational Philosophy */
  }
            <div className="lg:col-span-6 space-y-6">
              <span className="text-emerald-800 font-bold text-xs uppercase tracking-wider block">
                {lang === "bn" ? "\u0995\u09C7\u09A8 \u09AC\u09BE\u09AF\u09BC\u09A4\u09C1\u09B2 \u09AE\u09C1\u0995\u09BE\u09A6\u09CD\u09A6\u09BE\u09B8?" : "Why Baitul Muqaddas Model Madrasah?"}
              </span>
              <h2 className="text-2xl sm:text-4xl font-serif font-bold text-slate-900 tracking-tight text-balance">
                {lang === "bn" ? "\u098F\u0995\u099F\u09BF \u09B6\u09BE\u09A8\u09CD\u09A4, \u09A8\u09BF\u09B0\u09CD\u09AE\u09B2 \u0993 \u0986\u09A6\u09B0\u09CD\u09B6 \u09AA\u09B0\u09BF\u09AC\u09C7\u09B6\u09C7 \u09B8\u09A8\u09CD\u09A4\u09BE\u09A8\u09C7\u09B0 \u09AE\u09BE\u09A8\u09B8\u09BF\u0995 \u09AC\u09BF\u0995\u09BE\u09B6" : "A Peaceful, Nurturing Sanctuary for Academic & Spiritual Growth"}
              </h2>
              <p className="text-sm sm:text-base text-slate-600 leading-relaxed">
                {lang === "bn" ? "\u09A4\u09C1\u09B2\u09BE\u09A4\u09B2\u09C0 \u09AC\u09BE\u099C\u09BE\u09B0\u09C7\u09B0 \u09A8\u09BF\u0995\u099F\u09AC\u09B0\u09CD\u09A4\u09C0 \u09AA\u09CD\u09B0\u09BE\u0995\u09C3\u09A4\u09BF\u0995 \u0995\u09CB\u09B2\u09BE\u09B9\u09B2\u09AE\u09C1\u0995\u09CD\u09A4 \u09B8\u09AC\u09C1\u099C \u099A\u09A4\u09CD\u09AC\u09B0\u09C7 \u0985\u09AC\u09B8\u09CD\u09A5\u09BF\u09A4 \u0986\u09AE\u09BE\u09A6\u09C7\u09B0 \u09B8\u09C1\u09AC\u09BF\u09B6\u09BE\u09B2 \u09A6\u09CB\u09A4\u09B2\u09BE \u0995\u09CD\u09AF\u09BE\u09AE\u09CD\u09AA\u09BE\u09B8\u0964 \u098F\u0996\u09BE\u09A8\u09C7 \u09B0\u09DF\u09C7\u099B\u09C7 \u09AE\u09A8\u09CB\u09B0\u09AE \u099C\u09BE\u09AE\u09C7 \u09AE\u09B8\u099C\u09BF\u09A6, \u09AC\u09BE\u09A4\u09BE\u09B8 \u099A\u09B2\u09BE\u099A\u09B2 \u0989\u09AA\u09AF\u09CB\u0997\u09C0 \u0996\u09BF\u09B2\u09BE\u09A8\u09AF\u09C1\u0995\u09CD\u09A4 \u09B6\u09CD\u09B0\u09C7\u09A3\u09BF\u0995\u0995\u09CD\u09B7 \u098F\u09AC\u0982 \u0985\u09AD\u09BF\u099C\u09CD\u099E \u0993 \u09B8\u09CD\u09A8\u09C7\u09B9\u09B6\u09C0\u09B2 \u09B6\u09BF\u0995\u09CD\u09B7\u0995\u09AE\u09A3\u09CD\u09A1\u09B2\u09C0\u0964" : "Located beside Tulatoli Bazar in Daganbhuiyan, Feni, our campus features elegant arched verandas, a spacious Jam-e Masjid, hygienic water facilities, and dedicated teachers committed to character formation."}
              </p>

              <div className="space-y-3.5 pt-2">
                <div className="flex items-start gap-3">
                  <CheckCircle2 className="w-5 h-5 text-emerald-700 shrink-0 mt-0.5" />
                  <div>
                    <strong className="text-sm text-slate-900 block font-semibold">
                      {lang === "bn" ? "\u09B8\u09B9\u09C0\u09B9 \u0995\u09C1\u09B0\u0986\u09A8 \u0993 \u09B8\u09C1\u09A8\u09CD\u09A6\u09B0 \u09B9\u09B8\u09CD\u09A4\u09B2\u09BF\u09AA\u09BF" : "Quran with Tajweed & Handwriting Excellence"}
                    </strong>
                    <span className="text-xs text-slate-600">
                      {lang === "bn" ? "\u099A\u0995-\u09B8\u09CD\u09B2\u09C7\u099F\u09C7 \u09AC\u09B0\u09CD\u09A3\u09AE\u09BE\u09B2\u09BE\u09B0 \u09B8\u09C2\u0995\u09CD\u09B7\u09CD\u09AE \u09B0\u09C2\u09AA\u09BE\u09AF\u09BC\u09A8 \u0993 \u0987\u0982\u09B0\u09C7\u099C\u09BF \u099F\u09BE\u09A8\u09BE \u09B9\u09BE\u09A4\u09C7\u09B0 \u09B2\u09C7\u0996\u09BE\u09B0 \u09AC\u09BF\u09B6\u09C7\u09B7 \u09AA\u09CD\u09B0\u09B6\u09BF\u0995\u09CD\u09B7\u09A3\u0964" : "Hands-on slate practice for Arabic calligraphy and cursive English script."}
                    </span>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <CheckCircle2 className="w-5 h-5 text-emerald-700 shrink-0 mt-0.5" />
                  <div>
                    <strong className="text-sm text-slate-900 block font-semibold">
                      {lang === "bn" ? "\u09A8\u09C2\u09B0\u09BE\u09A8\u09C0 \u0993 \u09B8\u09AE\u09A8\u09CD\u09AC\u09BF\u09A4 \u09AA\u09CD\u09B0\u09BE\u09A5\u09AE\u09BF\u0995 \u09B6\u09BE\u0996\u09BE" : "Noorani Foundation & Primary Section (NCTB)"}
                    </strong>
                    <span className="text-xs text-slate-600">
                      {lang === "bn" ? "\u09AA\u09CD\u09B2\u09C7 \u09A5\u09C7\u0995\u09C7 \u09EB\u09AE \u09B6\u09CD\u09B0\u09C7\u09A3\u09BF \u09AA\u09B0\u09CD\u09AF\u09A8\u09CD\u09A4 \u09B8\u09B0\u0995\u09BE\u09B0 \u0985\u09A8\u09C1\u09AE\u09CB\u09A6\u09BF\u09A4 \u09AA\u09BE\u09A0\u09CD\u09AF\u09AC\u0987 \u0993 \u09A6\u09CD\u09AC\u09C0\u09A8\u09BF \u09B6\u09BF\u0995\u09CD\u09B7\u09BE\u09B0 \u09AA\u09C2\u09B0\u09CD\u09A3 \u09AE\u09C7\u09B2\u09AC\u09A8\u09CD\u09A7\u09A8\u0964" : "Seamless progression from early childhood Noorani method into standard primary classes."}
                    </span>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <CheckCircle2 className="w-5 h-5 text-emerald-700 shrink-0 mt-0.5" />
                  <div>
                    <strong className="text-sm text-slate-900 block font-semibold">
                      {lang === "bn" ? "\u09A4\u09BE\u09B9\u09AB\u09BF\u099C\u09C1\u09B2 \u0995\u09C1\u09B0\u0986\u09A8 \u0993 \u0989\u09A8\u09CD\u09A8\u09A4 \u09B9\u09CB\u09B8\u09CD\u099F\u09C7\u09B2" : "Tahfizul Quran Track & Boarding Care"}
                    </strong>
                    <span className="text-xs text-slate-600">
                      {lang === "bn" ? "\u09B9\u09BE\u09AB\u09C7\u099C \u09B6\u09BF\u0995\u09CD\u09B7\u0995\u09C7\u09B0 \u09A8\u09BF\u09AC\u09BF\u09DC \u09A4\u09A6\u09BE\u09B0\u0995\u09BF, \u09A8\u09BF\u09DF\u09AE\u09BF\u09A4 \u09AE\u09C1\u09B0\u09BE\u09AF\u09BE\u09B9\u09BE \u098F\u09AC\u0982 \u09AA\u09C1\u09B7\u09CD\u099F\u09BF\u0995\u09B0 \u0996\u09BE\u09AC\u09BE\u09B0\u0964" : "Focused memorization circles with regular revision rounds in a disciplined boarding wing."}
                    </span>
                  </div>
                </div>
              </div>

              <div className="pt-4 flex flex-wrap gap-4">
                <button
    onClick={() => onNavigate("contact")}
    className="px-6 py-3 text-xs font-bold text-white bg-emerald-800 hover:bg-emerald-900 rounded-lg shadow-sm cursor-pointer"
  >
                  {lang === "bn" ? "\u09B8\u09B0\u09BE\u09B8\u09B0\u09BF \u09AD\u09B0\u09CD\u09A4\u09BF \u09A4\u09A5\u09CD\u09AF \u099C\u09BE\u09A8\u09A4\u09C7 \u0995\u09B2 \u0995\u09B0\u09C1\u09A8" : "Inquire for Admissions"}
                </button>
                <button
    onClick={() => onNavigate("about")}
    className="px-6 py-3 text-xs font-semibold text-slate-700 bg-stone-100 hover:bg-stone-200 rounded-lg border border-stone-200 cursor-pointer"
  >
                  {lang === "bn" ? "\u09B6\u09BF\u0995\u09CD\u09B7\u0995 \u0993 \u09AA\u09B0\u09BF\u099A\u09BE\u09B2\u09A8\u09BE \u09AA\u09B0\u09CD\u09B7\u09A6" : "Meet Our Faculty"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {
    /* 5. CAMPUS OFFICE & LOCATION (Fully Dynamic from Settings) */
  }
      <section className="py-16 bg-stone-50 border-t border-stone-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-3xl border border-stone-200 p-8 sm:p-12 shadow-sm">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
              <div className="lg:col-span-7 space-y-5">
                <div className="inline-flex items-center gap-2 px-3 py-1 bg-amber-100 text-amber-900 rounded-lg text-xs font-bold uppercase tracking-wider">
                  <Building2 className="w-4 h-4 text-amber-700" />
                  <span>{lang === "bn" ? settings.campus_office_title_bn || "\u0995\u09CD\u09AF\u09BE\u09AE\u09CD\u09AA\u09BE\u09B8 \u0985\u09AB\u09BF\u09B8" : settings.campus_office_title || "Campus Administrative Office"}</span>
                </div>

                <h2 className="text-2xl sm:text-3xl font-serif font-bold text-slate-900">
                  {lang === "bn" ? settings.campus_office_location_bn || "\u09A4\u09C1\u09B2\u09BE\u09A4\u09B2\u09C0 \u09AC\u09BE\u099C\u09BE\u09B0 \u09B8\u0982\u09B2\u0997\u09CD\u09A8 \u09AE\u09C2\u09B2 \u0995\u09CD\u09AF\u09BE\u09AE\u09CD\u09AA\u09BE\u09B8" : settings.campus_office_location || "Central Academic Building, 1st Floor, Main Campus"}
                </h2>

                <p className="text-xs sm:text-sm text-slate-600 leading-relaxed">
                  {lang === "bn" ? settings.campus_office_landmark_bn || "\u09A4\u09C1\u09B2\u09BE\u09A4\u09B2\u09C0 \u09AC\u09BE\u099C\u09BE\u09B0 \u09B8\u0982\u09B2\u0997\u09CD\u09A8, \u09A6\u09BE\u0997\u09A8\u09AD\u09C2\u099E\u09BE, \u09AB\u09C7\u09A8\u09C0 (\u09A4\u09C1\u09B2\u09BE\u09A4\u09B2\u09C0 \u0995\u09C7\u09A8\u09CD\u09A6\u09CD\u09B0\u09C0\u09AF\u09BC \u099C\u09BE\u09AE\u09C7 \u09AE\u09B8\u099C\u09BF\u09A6\u09C7\u09B0 \u09AA\u09BE\u09B0\u09CD\u09B6\u09CD\u09AC\u09C7)" : settings.campus_office_landmark || "Adjacent to Tulatoli Bazar, Daganbhuiyan, Feni (Near Tulatoli Central Jame Masjid)"}
                </p>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2 text-xs text-slate-700">
                  <div className="flex items-start gap-2.5 bg-stone-50 p-3 rounded-xl border border-stone-200">
                    <Clock className="w-4 h-4 text-amber-600 shrink-0 mt-0.5" />
                    <div>
                      <strong className="block text-slate-900 font-semibold">{lang === "bn" ? "\u0985\u09AB\u09BF\u09B8 \u09B8\u09AE\u09AF\u09BC\u09B8\u09C2\u099A\u09C0" : "Office Hours"}</strong>
                      <span>{lang === "bn" ? settings.campus_office_hours_bn || "\u09B6\u09A8\u09BF\u09AC\u09BE\u09B0 - \u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF\u09AC\u09BE\u09B0: \u09B8\u0995\u09BE\u09B2 \u09EE:\u09E6\u09E6 - \u09AC\u09BF\u0995\u09BE\u09B2 \u09EB:\u09E6\u09E6" : settings.campus_office_hours || "Saturday \u2013 Thursday: 8:00 AM \u2013 5:00 PM"}</span>
                    </div>
                  </div>

                  <div className="flex items-start gap-2.5 bg-stone-50 p-3 rounded-xl border border-stone-200">
                    <Phone className="w-4 h-4 text-emerald-700 shrink-0 mt-0.5" />
                    <div>
                      <strong className="block text-slate-900 font-semibold">{lang === "bn" ? "\u09B9\u099F\u09B2\u09BE\u0987\u09A8 \u09AB\u09CB\u09A8" : "Contact Hotline"}</strong>
                      <span>{settings.phone} ({settings.whatsapp})</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="lg:col-span-5 flex flex-col items-center justify-center p-6 bg-emerald-950 text-white rounded-2xl text-center space-y-4 shadow-md">
                <ShieldCheck className="w-12 h-12 text-amber-400" />
                <h3 className="text-lg font-bold font-serif">
                  {lang === "bn" ? "\u0995\u09CD\u09AF\u09BE\u09AE\u09CD\u09AA\u09BE\u09B8 \u09AA\u09B0\u09BF\u09A6\u09B0\u09CD\u09B6\u09A8\u09C7\u09B0 \u0986\u09AE\u09A8\u09CD\u09A4\u09CD\u09B0\u09A3" : "Visit Our Campus in Person"}
                </h3>
                <p className="text-xs text-emerald-200/90 leading-relaxed">
                  {lang === "bn" ? settings.address_bn : settings.address}
                </p>
                <button
    onClick={() => onNavigate("contact")}
    className="px-6 py-2.5 bg-amber-400 hover:bg-amber-300 text-emerald-950 rounded-xl text-xs font-bold transition-all cursor-pointer shadow-sm"
  >
                  {lang === "bn" ? "\u09AF\u09CB\u0997\u09BE\u09AF\u09CB\u0997 \u0993 \u09AD\u09B0\u09CD\u09A4\u09BF \u09A4\u09A5\u09CD\u09AF" : "Campus Office & Map"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {
    /* 6. LATEST NEWS & BLOG POSTS */
  }
      <section className="py-20 bg-stone-100/70 border-t border-stone-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-12 gap-4">
            <div>
              <span className="text-emerald-800 font-bold text-xs uppercase tracking-wider block mb-1">
                {lang === "bn" ? "\u09AE\u09BE\u09A6\u09CD\u09B0\u09BE\u09B8\u09BE\u09B0 \u0996\u09AC\u09B0 \u0993 \u09A8\u09BF\u09AC\u09A8\u09CD\u09A7" : "Articles & Circulars"}
              </span>
              <h2 className="text-2xl sm:text-3xl font-serif font-bold text-slate-900 tracking-tight">
                {lang === "bn" ? "\u09B8\u09B0\u09CD\u09AC\u09B6\u09C7\u09B7 \u09B8\u0982\u09AC\u09BE\u09A6 \u0993 \u09B6\u09BF\u0995\u09CD\u09B7\u09BE\u09AE\u09C2\u09B2\u0995 \u09AA\u09CD\u09B0\u09AC\u09A8\u09CD\u09A7" : "Latest News & Educational Articles"}
              </h2>
            </div>
            <button
    onClick={() => onNavigate("blog")}
    className="text-xs font-bold text-emerald-800 hover:text-emerald-950 flex items-center gap-1 cursor-pointer"
  >
              <span>{lang === "bn" ? "\u09B8\u0995\u09B2 \u09AC\u09CD\u09B2\u0997 \u09A6\u09C7\u0996\u09C1\u09A8" : "View All Posts"}</span>
              <ChevronRight className="w-4 h-4" />
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {publishedPosts.map((post) => <article
    key={post.id}
    onClick={() => onNavigate("blog")}
    className="bg-white rounded-xl border border-stone-200 overflow-hidden shadow-xs hover:shadow-md transition-all cursor-pointer flex flex-col group"
  >
                <div className="h-44 overflow-hidden bg-stone-100 relative">
                  <img
    src={resolveImageUrl(post.cover_image)}
    alt={post.title}
    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
    referrerPolicy="no-referrer"
  />
                  <span className="absolute top-2.5 left-2.5 bg-emerald-950/85 text-amber-300 text-[10px] font-bold px-2 py-0.5 rounded tracking-wide backdrop-blur-xs">
                    {post.category}
                  </span>
                </div>

                <div className="p-5 flex-1 flex flex-col justify-between">
                  <div>
                    <div className="flex items-center gap-2 text-[11px] text-slate-500 mb-2">
                      <span>{post.author_name}</span>
                      <span aria-hidden="true">·</span>
                      <span>{post.created_at.substring(0, 10)}</span>
                      <span aria-hidden="true">·</span>
                      <span>{post.read_time}</span>
                    </div>

                    <h3 className="text-base font-bold text-slate-900 line-clamp-2 group-hover:text-emerald-800 transition-colors">
                      {lang === "bn" ? post.title_bn : post.title}
                    </h3>

                    <p className="mt-2 text-xs text-slate-600 line-clamp-3 leading-relaxed">
                      {lang === "bn" ? post.excerpt_bn : post.excerpt}
                    </p>
                  </div>

                  <div className="mt-4 pt-3 border-t border-stone-100 flex items-center text-xs font-semibold text-emerald-800 group-hover:text-emerald-950">
                    <span>{lang === "bn" ? "\u09AC\u09BF\u09B8\u09CD\u09A4\u09BE\u09B0\u09BF\u09A4 \u09AA\u09DC\u09C1\u09A8" : "Read Full Article"}</span>
                    <ChevronRight className="w-3.5 h-3.5 ml-1 group-hover:translate-x-0.5 transition-transform" />
                  </div>
                </div>
              </article>)}
          </div>
        </div>
      </section>

      {
    /* 7. ADMISSION INQUIRY STRIP */
  }
      <section className="bg-emerald-900 text-white py-14 border-t border-emerald-800">
        <div className="max-w-5xl mx-auto px-4 text-center space-y-5">
          <span className="text-amber-400 font-bold text-xs uppercase tracking-widest block font-sans">
            {lang === "bn" ? "\u09E8\u09E6\u09E8\u09EC \u09B6\u09BF\u0995\u09CD\u09B7\u09BE\u09AC\u09B0\u09CD\u09B7\u09C7 \u09AD\u09B0\u09CD\u09A4\u09BF" : "Admissions Open 2026"}
          </span>
          <h2 className="text-2xl sm:text-4xl font-serif font-bold tracking-tight text-balance">
            {lang === "bn" ? "\u0986\u09AA\u09A8\u09BE\u09B0 \u09B8\u09A8\u09CD\u09A4\u09BE\u09A8\u0995\u09C7 \u09A6\u09BF\u09A8 \u0987\u09B9\u0995\u09BE\u09B2\u09C0\u09A8 \u0993 \u09AA\u09B0\u0995\u09BE\u09B2\u09C0\u09A8 \u09B6\u09CD\u09B0\u09C7\u09B7\u09CD\u09A0 \u09B8\u09AE\u09CD\u09AA\u09A6" : "Give Your Child the Best Gift: Sacred Knowledge & Practical Competence"}
          </h2>
          <p className="text-sm text-emerald-100/90 max-w-xl mx-auto">
            {lang === "bn" ? "\u09B8\u09C0\u09AE\u09BF\u09A4 \u0986\u09B8\u09A8\u09C7 \u09AD\u09B0\u09CD\u09A4\u09BF \u099A\u09B2\u099B\u09C7\u0964 \u0995\u09CD\u09AF\u09BE\u09AE\u09CD\u09AA\u09BE\u09B8 \u09AA\u09B0\u09BF\u09A6\u09B0\u09CD\u09B6\u09A8 \u0995\u09B0\u09C1\u09A8 \u0985\u09A5\u09AC\u09BE \u0985\u09A8\u09B2\u09BE\u0987\u09A8\u09C7 \u0986\u09AA\u09A8\u09BE\u09B0 \u09A4\u09A5\u09CD\u09AF \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8 \u0995\u09B0\u09C7 \u0985\u0997\u09CD\u09B0\u09BF\u09AE \u0986\u09B8\u09A8 \u09A8\u09BF\u09B6\u09CD\u099A\u09BF\u09A4 \u0995\u09B0\u09C1\u09A8\u0964" : "Limited seats available in Noorani, Hifz, and Primary Class 1-5. Visit our campus or submit an inquiry today."}
          </p>
          <div className="pt-2 flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
    onClick={() => onNavigate("contact")}
    className="px-8 py-3.5 text-xs font-bold text-emerald-950 bg-amber-400 hover:bg-amber-300 rounded-full shadow-md transition-all cursor-pointer"
  >
              {lang === "bn" ? "\u0985\u09A8\u09B2\u09BE\u0987\u09A8 \u09AD\u09B0\u09CD\u09A4\u09BF \u0986\u09AC\u09C7\u09A6\u09A8 \u09AB\u09B0\u09AE" : "Fill Out Admission Form"}
            </button>
            <a
    href={`https://wa.me/${(settings?.whatsapp || "8801712345678").replace(/[^0-9]/g, "")}`}
    target="_blank"
    rel="noopener noreferrer"
    className="px-6 py-3 text-xs font-semibold text-white border border-emerald-400/50 hover:bg-emerald-800/80 rounded-full transition-all flex items-center gap-2"
  >
              <span>{lang === "bn" ? "\u09B9\u09CB\u09AF\u09BC\u09BE\u099F\u09B8\u0985\u09CD\u09AF\u09BE\u09AA\u09C7 \u0995\u09A5\u09BE \u09AC\u09B2\u09C1\u09A8" : "Chat on WhatsApp"}</span>
            </a>
          </div>
        </div>
      </section>
    </div>;
};
